import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.date.now";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { objectToFormData } from 'object-to-formdata';
var m = {
  namespaced: true,
  state: {
    pageData: {},
    notice: []
  },
  mutations: {
    setPageData: function setPageData(state, _a) {
      var page = _a.page,
          data = _a.data;
      Vue.set(state.pageData, page, data);
    },

    /**
     * 记录系统通知
     */
    setNotice: function setNotice(state, notice) {
      state.notice = notice;
    }
  },
  actions: {
    /**
     * 用于获取系统通知
     */
    getNotice: function getNotice(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, list;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/notice')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = (rdata.data || []).map(function (item) {
                  return item.content;
                });
                context.commit('setNotice', list);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取上传配置
     */
    getUploadConfig: function getUploadConfig(context, _a) {
      var type = _a.type,
          ext = _a.ext;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/upload_config', {
                params: {
                  type: type,
                  ext: ext,
                  t: Math.random()
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    uploadToAliyun: function uploadToAliyun(context, _a) {
      var file = _a.file,
          uploadConfig = _a.uploadConfig;
      return __awaiter(this, void 0, void 0, function () {
        var data, ret, end, response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              data = objectToFormData({
                key: uploadConfig.key,
                OSSAccessKeyId: uploadConfig.access_key_id,
                // 'x-oss-security-token': uploadConfig.sts_token,
                policy: uploadConfig.policy,
                Signature: uploadConfig.signature,
                file: file
              });
              ret = false;
              end = 0;
              return [4
              /*yield*/
              , Vue.axios.post(uploadConfig.host, data, {
                // withCredentials: true,
                timeout: 0,
                headers: {
                  Origin: 'http://hundred-test.xorout.com'
                }
              }).then(function (response) {
                ret = true;
                end = Date.now();
                return {
                  status: 200,
                  data: {
                    status: 0,
                    message: 'OK',
                    data: {
                      key: uploadConfig.key,
                      url: uploadConfig.url
                    }
                  }
                };
              })["catch"](function (err) {
                ret = true;
                end = Date.now();
                return {
                  // 报错
                  status: 500,
                  data: {
                    status: -1,
                    message: '啊哦，上传出现了点小问题',
                    data: {
                      url: '',
                      key: ''
                    }
                  }
                };
              })];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },
    configAndUploadToAliyun: function configAndUploadToAliyun(context, _a) {
      var file = _a.file,
          type = _a.type;
      return __awaiter(this, void 0, void 0, function () {
        var name, pos, ext, rdata, uploadRdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              name = file.name;
              pos = name.lastIndexOf('.');
              ext = pos >= 0 ? name.substr(pos + 1) : 'ukn';
              return [4
              /*yield*/
              , context.dispatch('getUploadConfig', {
                type: type,
                ext: ext
              })];

            case 1:
              rdata = _b.sent();

              if (rdata.status !== 0) {
                _Toast(rdata.message);

                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , context.dispatch('uploadToAliyun', {
                file: file,
                uploadConfig: rdata.data
              })];

            case 2:
              uploadRdata = _b.sent();

              if (rdata.status !== 0) {
                _Toast(rdata.message);

                return [2
                /*return*/
                ];
              }

              return [2
              /*return*/
              , uploadRdata];
          }
        });
      });
    }
  }
};
export default m;